var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/utility-registry-image.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/utility-registry-image.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("staticUrl")) {
var t_4 = t_1.staticUrl;
} else {
cb(new Error("cannot import 'staticUrl'")); return;
}
context.setVariable("staticUrl", t_4);
output += "<img src=\"";
output += runtime.suppressValue((lineno = 2, colno = 20, runtime.callWrap(t_4, "staticUrl", context, ["/images/header/registry-icon.svg"])), env.opts.autoescape);
output += "\" class=\"c-utility__svg c-utility__svg--registry\" alt=\"";
output += runtime.suppressValue((lineno = 2, colno = 113, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-registry"])), env.opts.autoescape);
output += "\"/>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/utility-registry-image.j2"] , dependencies)